import { Post } from '@/utils/axios'

/**
POST
/app/Login/GetJwtToken
app用户登录
 */
export function login(data) {
  return Post('/Login/GetJwtToken', data)
}

/**
 * 注册
 * @param {*} data { "userName": "string", "passWord": "string", "confirmPassWord": "string", "referralCode": "string", "storeId": 0, "email": "string", "skype": "string", "whatsapp": "string" }
 * @returns
 */
export function register(data) {
  return Post('/Login/Register', data)
}

/**
 * 退出系统
 */
export function logout() {
  return { success: true, message: 'SUCCESS!' }
}

export function codeLogin(code) {
  return Post('/Login/LoginByCode', { code })
}

/**
 * 给邮箱发送验证码
 * @param {*} data
 * @returns
 */
export function sendEmailCode(data) {
  return Post('/Login/SendEmailCode', data)
}

/**
 * 忘记密码
 * @param {*} data
 * @returns
 */
export function forgotPassword(data) {
  return Post('/Login/ForgotPassword', data)
}
